import { Avatar, Box, Button, Grid, Typography, useTheme } from "@material-ui/core";
import React, { useEffect } from "react";
import { Order, ExecutionType } from "../../../Shared/GeneratedTypes";
import useInterval from "../../../Shared/useInterval";
import { DateTime } from "luxon";
import { Localizations } from "../../../Shared/sharedTypes";

interface propsType {
    next: () => void;
    updateSchedule: () => void;
    order: Order;
    localizations: Localizations;
}
export default function ScheduleConfirmation({ order, next, updateSchedule, localizations }: propsType) {
    let scheduledDate = order.scheduledDate! as DateTime;
    let theme = useTheme();

    const checkSchedule = () => {
        var hours = scheduledDate.diff(DateTime.local(), "hours");
        if (hours.hours <= 1) {
            next();
        }
    };

    useInterval(checkSchedule, 60000);
    useEffect(() => {
        checkSchedule();
    }, []);

    return (
        <>
            <Grid
                item
                className="transparentBackground"
                container
                style={{ flex: 1, backgroundColor: "#85C441AA", padding: "64px 24px" }}
            >
                <Box p={3} borderRadius={20} textAlign="center" style={{ backgroundColor: "white", flex: 1 }}>
                    <Typography variant="h5">{localizations.youreAllSet}</Typography>
                    <Typography variant="body1">{localizations.scheduledForTimeSlot}</Typography>
                    <Box m={2}>
                        <Typography style={{ color: theme.palette.primary.main, fontSize: "1.3em" }}>
                            {scheduledDate.toLocaleString(DateTime.DATE_MED)} <br />
                            {scheduledDate.toLocaleString(DateTime.TIME_WITH_SHORT_OFFSET)}
                        </Typography>
                    </Box>
                    <Typography style={{ fontWeight: "bold", marginBottom: theme.spacing(2) }}>
                        {localizations.notificationForSchedule}
                    </Typography>
                    {order.executionType === ExecutionType.Scheduled && (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={updateSchedule}
                            style={{ marginBottom: 10 }}
                        >
                            {localizations.updateSchedule}
                        </Button>
                    )}
                </Box>
            </Grid>
        </>
    );
}
